import { useState } from "react";
import CirclePack from './CirclePack';
import './App.css';

function App() {

  const [selectedRole, setSelectedRole] = useState({});

  const onRoleChange = (role) => {
    console.log(role);
    setSelectedRole(role);
  }

  return (
    <div className="circle-area">
      <a
        href="https://mkpconnect.org/policy/mkp-usa-holacracy-based-operating-system"
        target="_blank"
        rel="noreferrer noopener"
        className="constitution-link"
      >
        MKP USA Constitution
      </a>
      <div className="circle-pack-area">
        <CirclePack onRoleChange={onRoleChange}/>
      </div>
      <div className="circle-content-area">
        <h3>
          {selectedRole && selectedRole.role_name}
        </h3>
        <pre>
          {selectedRole && selectedRole.text}
        </pre>
      </div>
    </div>
  );
}

export default App;
